import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, TextField, DialogTitle, CircularProgress } from '@mui/material';
import ResponsiveDialog, { ResponsiveDialogActions, ResponsiveDialogContent } from 'components/responsive-dialog';

type SaveTableTemplateDialogProps = {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
};

const SaveTableTemplateDialog = ({ open, loading, onClose, onSave }: SaveTableTemplateDialogProps) => {
  // useState hooks
  const [name, setName] = useState('');

  // useEffect hooks
  useEffect(() => {
    if (open) setName('');
  }, [open]);

  return (
    <ResponsiveDialog open={open} onClose={() => !loading && onClose()} maxWidth="xs">
      <DialogTitle>
        <FormattedMessage id="datagrid.saveTemplate" defaultMessage="Şablon Kaydet" />
      </DialogTitle>
      <ResponsiveDialogContent sx={{ pt: 2 }}>
        <TextField
          autoFocus
          fullWidth
          label={<FormattedMessage id="datagrid.templateName" defaultMessage="Şablon adı" />}
          value={name}
          disabled={loading}
          onChange={(e) => setName(e.target.value)}
          sx={{ mt: 1.5 }}
        />
      </ResponsiveDialogContent>
      <ResponsiveDialogActions>
        <Button onClick={onClose} disabled={loading}>
          <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />
        </Button>
        <Button
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
          onClick={() => void onSave(name.trim())}>
          <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />
        </Button>
      </ResponsiveDialogActions>
    </ResponsiveDialog>
  );
};

export default SaveTableTemplateDialog;
